module.exports = __webpack_public_path__ + "static/media/trump-right-gray.0b4f9768.svg";